import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Container from './../../components/outPages/Container';
import Main from '../../layouts/Main';
import {
  Faq,
  Main as MainSection,
  Support,
  PricingCompareTable,
} from './components';

const Pricing = () => {
  return (
    <Main>
      <MainSection />
      <Box bgcolor={'rgb(243, 250, 255)'}>
        <Container>
          <Support />
        </Container>
      </Box>
      <Container>
        <PricingCompareTable />
      </Container>
      <Container maxWidth={400} paddingY={'0 !important'}>
        <Divider />
      </Container>
      <Container>
        <Faq />
      </Container>
    </Main>
  );
};

export default Pricing;
